// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var traverse_ = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Effect.bindEffect);
var triggerCallback = function () {
    return identity;
};
var newCallback = function () {
    return function (dictMonadEffect) {
        return Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(function (v) {
            return {
                event: v.event,
                callback: v.fire
            };
        })(Specular_FRP_Base.newEvent(dictMonadEffect));
    };
};
var mkCallback = function () {
    return identity;
};
var mbCallback = function () {
    return traverse_;
};
var dynCallback = function () {
    return function (dynCb) {
        return function (x) {
            return function __do() {
                var cb = readDynamic(dynCb)();
                return cb(x)();
            };
        };
    };
};
var contramapCallbackEffect = function () {
    return function (f) {
        return function (cb) {
            return composeKleisli(f)(cb);
        };
    };
};
var contramapCallbackDyn_ = function () {
    return function (fD) {
        return function (cb) {
            return function (v) {
                return function __do() {
                    var f = readDynamic(fD)();
                    return cb(f)();
                };
            };
        };
    };
};
var contramapCallbackDynMaybe = function () {
    return function (fD) {
        return function (cb) {
            return function (x) {
                return function __do() {
                    var f = readDynamic(fD)();
                    return traverse_(cb)(f(x))();
                };
            };
        };
    };
};
var contramapCallbackDyn = function () {
    return function (fD) {
        return function (cb) {
            return function (x) {
                return function __do() {
                    var f = readDynamic(fD)();
                    return cb(f(x))();
                };
            };
        };
    };
};
var attachEvent = function () {
    return function (dictMonadFRP) {
        var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1());
        return function (event) {
            return function (cb) {
                return subscribeEvent_(cb)(event);
            };
        };
    };
};
var attachDyn = function () {
    return function (dictMonadFRP) {
        var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
        return function (dyn) {
            return function (cb) {
                return subscribeDyn_(cb)(dyn);
            };
        };
    };
};
export {
    newCallback,
    attachEvent,
    attachDyn,
    contramapCallbackDyn,
    contramapCallbackDyn_,
    contramapCallbackDynMaybe,
    contramapCallbackEffect,
    dynCallback,
    mbCallback,
    mkCallback,
    triggerCallback
};
